import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DataServiceApiConstants } from '@ddt-web/data-service';

import { HoldingsConstants } from '../config/holdings.constants';

/**
 * EmptyPortfolioDirective is a structural directive that determines if the template content should be displayed based on the number of portfolios
 * If the number of portfolios matches the value in the app constants, the 'empty portfolio' content is shown
 *
 * @param portfolios is either a number or an array. If it's a number we'll use it to compare with the constant. If it's an array, we'll use its length.
 *
 * ### Syntax
 *
 * - `<div *emptyPortfolio="portfolios.length">...</div>`
 * - `<ng-template [emptyPortfolio]="portfolioArr"><div>...</div></ng-template>`
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[emptyPortfolio]'
})
export class EmptyPortfolioDirective {

	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) { }

	@Input() public set emptyPortfolio(portfolios: number | Array<any>) {
		if (typeof portfolios === 'number') {
			this.showContent(portfolios);
		} else if (Array.isArray(portfolios)) {
			this.showContent(portfolios);
		} else {
			throw new Error('Value is not a number or an array');
		}
	}

	private showContent(portfolios: number | Array<any>): void {
		const portfolioLength = typeof portfolios === 'number' ? portfolios : portfolios.length;
		const isIncludeFtePortfolio = Array.isArray(portfolios) ? portfolios.some(portfolioId => portfolioId === DataServiceApiConstants.FTE_TRANSITION_ID) : false;

		if (portfolioLength === HoldingsConstants.NUMBER_PORTFOLIOS_TO_TRIGGER_EMPTY_COL && !isIncludeFtePortfolio) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}
}
